import * as React from 'react';
import { LoadingPage } from '@pages/LoadingPage';
import { CSSTransition } from 'react-transition-group';

export function withPageSuspense<TProps>(Component: React.FC<TProps>): React.FC<TProps> {
    const ComponentWithPageSuspense: React.FC<TProps> = (props: TProps) => {
        const [showComponent, setShowComponent] = React.useState(false);

        const FallbackLoading = React.useCallback(() => {
            // tslint:disable-next-line: react-hooks-nesting
            React.useEffect(() => {
                return () => {
                    setShowComponent(true);
                };
            }, []);

            return <LoadingPage isLoading={true} />;
        }, []);

        return (
            <React.Suspense fallback={<FallbackLoading />}>
                <CSSTransition
                    // tslint:disable-next-line
                    classNames="fade-in"
                    in={showComponent}
                    timeout={0}
                    exit={false}
                    appear={false}
                >
                    <Component {...props} />
                </CSSTransition>
            </React.Suspense>
        );
    };

    ComponentWithPageSuspense.displayName = `${Component.displayName || 'Component'}WithPageSuspense`;

    return ComponentWithPageSuspense;
}
